import { onMounted, onUnmounted, provide, ref } from "vue";
import JSBridge from '../bridge';

/**
 * 页面可见性管理
 */
export function useVisibility() {
  // 监听H5页面在app中是否可见
  const isH5Hidden = ref(false);
  provide('isH5Hidden', isH5Hidden);

  // document可见性状态
  let docHidden = false;
  // native可见性状态：null 代表尚未收到native事件
  let nativeHidden: boolean | null = null;

  const getDocumentHidden = () => {
    const hiddenProperty =
      'hidden' in document
        ? 'hidden'
        : 'webkitHidden' in document
          ? 'webkitHidden'
          : 'mozHidden' in document
            ? 'mozHidden'
            : null;

    return hiddenProperty ? Boolean((document as any)[hiddenProperty]) : false;
  };

  const syncHidden = () => {
    const nextHidden = docHidden || (nativeHidden ?? false);
    if (isH5Hidden.value !== nextHidden) {
      isH5Hidden.value = nextHidden;
    }
  };

  const visibilitychange = () => {
    docHidden = getDocumentHidden();
    console.log('visibilitychange', docHidden);
    syncHidden();
  };

  /**
   * 处理原生页面显示事件
   */
  const handleH5PageShow = () => {
    console.log('JSBridge.on：h5PageShow');
    // 安卓返回场景下，document可见性可能不及时，原生显示事件兜底修正为可见
    nativeHidden = false;
    docHidden = false;
    syncHidden();
  };

  /**
   * 处理webview通知H5可见事件
   */
  const handleH5PageVisible = () => {
    console.log('JSBridge.on：h5PageVisible');
    nativeHidden = false;
    syncHidden();
  };

  /**
   * 处理webview通知H5不可见事件
   */
  const handleH5PageInvisible = () => {
    console.log('JSBridge.on：h5PageInvisible');
    nativeHidden = true;
    syncHidden();
  };

  onMounted(() => {
    docHidden = getDocumentHidden();
    syncHidden();

    // 安卓的原生返回h5用visibilitychange监听不到，所以原生返回时调用h5PageShow
    JSBridge.on('h5PageShow', handleH5PageShow);
    JSBridge.on('h5PageVisible', handleH5PageVisible);
    JSBridge.on('h5PageInvisible', handleH5PageInvisible);
    document.addEventListener('visibilitychange', visibilitychange);
  });

  onUnmounted(() => {
    JSBridge.off('h5PageShow');
    JSBridge.off('h5PageVisible');
    JSBridge.off('h5PageInvisible');
    document.removeEventListener('visibilitychange', visibilitychange);
  });

  return {
    isH5Hidden,
    visibilitychange,
    handleH5PageShow,
    handleH5PageVisible,
    handleH5PageInvisible
  };
}
